import { createTheme } from "@mui/material/styles";

const CustomTheme = createTheme({
  palette: {
    // mode: "dark",
    primary: {
      main: "#2e7d32",
    },
    secondary: {
      main: "#435243",
    },
    error: {
      main: "#d32f2f",
    },
  },
});

export default CustomTheme;
